import styled from 'styled-components';

const GroupInputWrapper = styled.div`
  .flag {
    margin-right: 6px;
  }
  select {
    height: 100%;
    border: none;
    padding-left: 0;
  }
  select:focus {
    box-shadow: none;
  }
`;

export { GroupInputWrapper };
